/* eslint-disable */
import React from 'react'
import Select from 'react-select'
import {Link} from 'react-router-dom'
import http from '../../Component/Interceptor/Interseptor'
import {grid, gridColumn, gridToolbar} from '@progress/kendo-react-excel-export'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'

class HeaderGrid extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      defaultPageSize: 10
    }
  }
  setPage() {
    let pageSize = document.getElementById('pageSize').value
    this.props.getPageSize(pageSize)
  }
  componentDidMount() {
    if (this.props.defaultSize) {
      this.setState({
        defaultPageSize: this.props.defaultSize
      })
    }
  }

  render() {
    let {createLink, enablePageSize} = this.props
    return (
      <React.Fragment>
        <div className="optionButtons">
          {enablePageSize && (
            <select id="pageSize" onChange={this.setPage.bind(this)}>
              <option selected={this.state.defaultPageSize == '10' ? true : false} value="10">
                10
              </option>
              <option selected={this.state.defaultPageSize == '20' ? true : false} value="20">
                20
              </option>
              <option selected={this.state.defaultPageSize == '50' ? true : false} value="50">
                50
              </option>
              <option selected={this.state.defaultPageSize == '100' ? true : false} value="100">
                100
              </option>
              {/*<option value='200' selected={this.props.defaultValuePageSize === '200' ? true : false}>200</option>*/}
            </select>
          )}

          <div id="addWrapper" style={createLink == '' ? {display: 'none'} : {display: 'inline-block'}}>
            <Link to={createLink} id="addBaseInfo">
              افزودن
            </Link>
          </div>

          {/*<Link to={printUrl} class='printLink' target='_blank'*/}
          {/*      style={printLink == '' ? {display: 'none'} : {display: 'inline-block'}}>*/}
          {/*    <span>{this.props.subDispatch ? 'چاپ توزیع' :'چاپ فاکتور ها'}</span>*/}
          {/*</Link>*/}
        </div>
      </React.Fragment>
    )
  }
}

export default HeaderGrid
